import React from "react";

import { FaBookReader, FaBriefcase, FaCogs, FaDesktop, FaHandshake, FaShippingFast, FaTools, FaTruck } from "react-icons/fa";
import { HiLibrary } from "react-icons/hi";
import { MdDesignServices, MdHomeRepairService } from "react-icons/md";
import { GrServices } from "react-icons/gr";

const Feature = ({ filteredServices ,setModal,setTitle,setDescription}) => {
  // Icon mapping
  const iconMapping = {
    icon1: <FaBookReader />,
    icon2: <FaBriefcase />,
    icon3: <HiLibrary />,
    icon4: <FaDesktop />,
    icon5: <MdDesignServices />,
    icon6: <MdHomeRepairService />,
    icon7: <GrServices />,
    icon8: <FaTools />,
    icon9: <FaCogs />,
    icon10: <FaHandshake/>,
    icon11: <FaShippingFast />,
    icon12: <FaTruck />,
  };

  return (
    <div className="react_populars_topics react_populars_topics2 react_populars_topics_about pb---80">
      <div className="react__title__section react__title__section-all">
        <div className="row">
          <div className="col-md-12 text-center">
            <h6 className="wow animate__fadeInUp" data-wow-duration="0.3s">
              Our Services
            </h6>
            <h2
              className="react__tittle wow animate__fadeInUp"
              data-wow-duration="0.5s"
            >
              Our Other Services For You
             
            </h2>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row pt---30" >
        {filteredServices.length!==0 && filteredServices.map((service, index) => {
           
          
            const icon = iconMapping[service.icon] || null;

            return (
              <div
                key={service.id || index} // Prefer using unique 'id' as key
                className="col-md-3 wow animate__fadeInUp" style={{marginBottom:10}}
                data-wow-duration="0.3s"
              >
                <div className="item__inner" style={{height:"100%",cursor:"pointer"}} onClick={()=>{
                 setDescription(service.description)
                 setTitle(service.title)
                  setModal(true)}}>
                <div className="icon-container">
                    {/* Render the icon inside the container */}
                    {icon}
                  </div>
                  <div className="react-content">
                    <h3 className="react-title">
                      <a href="coureses-grid.html">{service.title}</a>
                    </h3>
                    <p className="card-description">
                      {service.description || "Service description goes here."}
                    </p>
                  
                    {/* <div className="social-father">
                  <a
                    className="fb"
                    href="https://www.facebook.com/yourfrenchteachers?mibextid=ZbWKwL"
                  >
                    <span aria-hidden="true" className="social_facebook"></span>
                  </a>
                  <a className="fb" href="mailto:info@reactheme.com">
                    <svg
                      className="social_facebook"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
                    </svg>
                  </a>
                  <a className="fb" href="tel:(+95) 401013010">
                    <svg
                      className="social_facebook"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z" />
                    </svg>
                  </a>
                </div> */}
                  </div>
                </div>
              </div>
            );
          })}
        
         
        </div>
      </div>
    </div>
  );
};

export default Feature;
